function formatNumber(x) {
  var parts = x.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return parts.join('.');
}

const addCommas = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');

const removeNonNumeric = (num) => num?.toString().replace(/[^0-9]/g, '') || '';

export { formatNumber, addCommas, removeNonNumeric };
